import React, { useState, useEffect } from 'react';
import './DashboardTelefonia.css';
import CardChamadas from './CardChamadas';
import GraficoTempo from './GraficoTempo';
import ListaChamadas from './ListaChamadas';
import DashboardCard from './DashboardCard';

function DashboardTelefonia({ username, onLogout }) {
  const [isDarkMode, setIsDarkMode] = useState(
    document.body.getAttribute('data-theme') === 'dark'
  );

  useEffect(() => {
    document.body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }, []);

  const [estatisticas, setEstatisticas] = useState({
    total: 0,
    efetuadas: 0,
    atendidas: 0,
    naoAtendidas: 0
  });

  const handleUpdateEstatisticas = (novasEstatisticas) => {
    console.log('Novas estatísticas:', novasEstatisticas); // Para debug
    setEstatisticas(novasEstatisticas);
  };

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    document.body.setAttribute('data-theme', newTheme ? 'dark' : 'light');
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1>Dashboard de Telefonia</h1>
        <div className="header-actions">
          <span className="username">
            <i className="fas fa-user"></i>
            {username}
          </span>
          <button className="theme-toggle" onClick={toggleTheme}>
            <i className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'}`}></i>
          </button>
          <button className="logout-button" onClick={onLogout}>
            <i className="fas fa-sign-out-alt"></i>
            Sair
          </button>
        </div>
      </header>
      
      <div className="cards-container">
        <DashboardCard
          titulo="Total de Chamadas"
          valor={estatisticas.total}
          icone="fa-phone"
        />
        <DashboardCard
          titulo="Chamadas Efetuadas"
          valor={estatisticas.efetuadas}
          icone="fa-arrow-up"
        />
        <DashboardCard
          titulo="Chamadas Atendidas"
          valor={estatisticas.atendidas}
          icone="fa-check"
          type="atendidas"
        />
        <DashboardCard
          titulo="Chamadas Não Atendidas"
          valor={estatisticas.naoAtendidas}
          icone="fa-times"
          type="nao-atendidas"
        />
      </div>

      <ListaChamadas onUpdateEstatisticas={handleUpdateEstatisticas} />
    </div>
  );
}

export default DashboardTelefonia; 